<template>
  <vx-card no-shadow>
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar
        v-bind:src="this.$store.state.avatar"
        size="70px"
        class="mr-4 mb-4"
      />

      <!-- Info -->
      <vs-input
        class="w-full mb-base"
        name="name"
        label-placeholder="Nome Completo"
        v-model="user.userName"
        v-validate="'required'"
      ></vs-input>
 
      <span class="text-danger text-sm" v-show="errors.has('name')">{{
        errors.first("name")
      }}</span>
      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button
          class="ml-auto mt-2"
          @click="updateUser"
          :disabled="!isFormValid"
          >Salvar</vs-button
        >
      </div>
    </div>
  </vx-card>
</template> 

<script>
import { Validator } from "vee-validate";
import axios from "axios";
import { baseApiUrl } from "@/global";
const dict = {
  custom: {
    name: {
      required: "Por favor insira seu nome.",
      alpha: "Your first name may only contain alphabetic characters",
    },
  },
};
Validator.localize("en", dict);
export default {
  data() {
    return {
      file: "",
      dataImg: null,
      user: {
        idUser: this.$store.state.user.idUser,
        userName: this.$store.state.user.userName,
      },
    };
  },
  computed: {
    isFormValid() { 
      return !this.errors.any() && this.user.userName;
    },
  },
  methods: {
    async updateUser() {
      try {  
        this.$vs.loading();
        let res = await axios.post(
          `${baseApiUrl}/user/updateUserName`,
          this.user
        );
        let userInfo = res.data.userInfo;
        this.$store.dispatch("updateUserInfo", userInfo);
        this.$vs.notify({
          title: "Salvo",
          text: "com Sucesso",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });
      } catch (error) {
        console.log(error)
        if (!error.response || !error.response.data) return;
        this.$vs.notify({
          title: "Erro",
          text: `Não foi possivel salvar ` + error.response.data,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
